export default {
  title: 'Przegląd',
  table_title: 'Rezerwacje',
  filters: {
    card_title: 'Filtry',
    today: 'Dzisiaj',
    upcoming: 'Nadchodzące',
    past: 'Minione',
    all: 'Wszystkie',
    all_dates: 'Cały czas',
    pending: 'Oczekuje na potwierdzenie',
    canceled: 'Anulowane',
    removed: 'Usunięte',
    date_label: 'Data:',
    status_label: 'Status:',
    source_label: 'Źródło:',
    source_website: 'Strona internetowa',
    source_google: 'Google',
    search_label: 'Szukaj:',
    search_placeholder: 'Szukaj po imieniu lub nazwisku',
    custom_date_tooltip: 'Wybierz konkretną datę',
    active_label: 'Aktywne filtry:',
    clear_all: 'Wyczyść wszystkie',
  },
  tooltips: {
    total_reservations: 'Łączna liczba rezerwacji',
    total_guests: 'Łączna liczba gości',
    refresh: 'Odśwież',
  },
  empty: {
    default: 'Brak rezerwacji.',
    filtered: 'Brak rezerwacji spełniających kryteria.',
  },
  fields: {
    company: 'Restauracja',
    datetime: 'Data / godzina',
    customer: 'Klient',
    source: 'Źródło',
    guests: 'Goście',
    status: 'Status',
    created_at: 'Utworzono',
  },
  status: {
    confirmed: 'Potwierdzona',
    pending: 'Oczekuje na zatwierdzenie',
    canceled: 'Anulowane',
    rejected: 'Odrzucona',
    removed: 'Usunięte',
  },
  buttons: {
    details: 'Szczegóły',
    add_reservation: 'Dodaj rezerwację',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
